import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import priceCont from '../../assets/price_cont4.png'; 
import priceContPro from '../../assets/price_cont5.png'; 
import priceContUlt from '../../assets/price_cont6.png'; 


import button3 from '../../assets/button6.png'; 
import buttonPro from '../../assets/button_pro.png'; 
import buttonUlt from '../../assets/button_ult.png'; 

import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

import './PurchaseSection.css';


const Purchase = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const CustomPlanClick = () => {
    if (user) {
      navigate('/subscribe', { state: { planId: 'custom' } });
    } else {
      navigate('/signup');
    }
  };

  const ProPlanClick = () => {
    if (user) {
      navigate('/subscribe', { state: { planId: 'pro' } });
    } else {
      navigate('/signup');
    }
  };

  const UltimatePlanClick = () => {
    if (user) {
      navigate('/subscribe', { state: { planId: 'ultimate' } });
    } else {
      navigate('/signup');
    }
  };

  return (
    <div>
      <div className="luna-section">
        <div style={{ height: '100px' }} />  

        <h1 data-aos="fade-down" data-aos-duration="700">
          Unlock your Full Potential
        </h1>
        <div className="image-row">
          <div
            className="image-container-price"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <img src={priceCont} alt="Wallet Search" />
            <button className="image-button-price" onClick={CustomPlanClick}>
              <img src={button3} alt="Button" draggable="false" />
            </button>
          </div>

          <div
            className="image-container-price"
            data-aos="fade-up"
            data-aos-duration="600"
            data-aos-delay="200"
          >
            <img src={priceContPro} alt="Crypto Balance" />
            <button className="image-button-price" onClick={ProPlanClick}>
              <img src={buttonPro} alt="Button" draggable="false" />
            </button>
          </div>

          <div
            className="image-container-price"
            data-aos="fade-up"
            data-aos-duration="600"
            data-aos-delay="400"
          >
            <img src={priceContUlt} alt="Referral Stats" />
            <button className="image-button-price" onClick={UltimatePlanClick}>
              <img src={buttonUlt} alt="Button" draggable="false" />
            </button>
          </div>
        </div>

        <p data-aos="fade-right" data-aos-duration="600">
          LunaSearch gives you the tools, the community, and the chance to rise,
          to build, to earn, and to move ahead while others hesitate. Start
          searching, start tracking, and start becoming more than a bystander in
          crypto.
        </p>
      </div>
    </div>    
  );
};

export default Purchase;